import { can } from "../../../../shared/auth/access";
import type { SessionUser } from "../../../../shared/auth/access";
import { useRfqData } from "./useRfqData";
import { useRfqInvitationData } from "./useRfqInvitationData";
import { useRfqGovernanceData } from "./useRfqGovernanceData";

export function useRfqWorkspaceData(props: { requestNo: string; user: SessionUser; notify: (message: string) => void }) {
  const data = useRfqData(props);
  const canManageInvitations = can(props.user, "rfq.invitation.manage") || (props.user.preview === true && can(props.user, "rfq.manage"));
  const invitations = useRfqInvitationData({ scope: data.scope, rfq: data.rfq, canManageInvitations });
  const governance = useRfqGovernanceData({ scope: data.scope, rfq: data.rfq, user: props.user });
  return { ...data, ...invitations, ...governance, canManageInvitations };
}
